import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Appointments from "@/pages/dashboard/Appointments";
import BookAppointment from "@/pages/dashboard/BookAppointment";
import Services from "@/pages/dashboard/Services";
import Staff from "@/pages/dashboard/Staff";
import Customers from "@/pages/dashboard/Customers";
import Inventory from "@/pages/dashboard/Inventory";
import Products from "@/pages/dashboard/Products";
import Suppliers from "@/pages/dashboard/Suppliers";
import Purchases from "@/pages/dashboard/Purchases";
import Invoices from "@/pages/dashboard/Invoices";
import QuickSale from "@/pages/dashboard/QuickSale";
import ProductSale from "@/pages/dashboard/ProductSale";
import ComingSoon from "@/pages/dashboard/ComingSoon";
import SalaryRules from "@/pages/dashboard/SalaryRules";
import Payroll from "@/pages/dashboard/Payroll";
import LeaveRequest from "@/pages/dashboard/LeaveRequest";
import CalendarPage from "@/pages/dashboard/Calendar";
import Settings from "@/pages/dashboard/Settings";
import Notifications from "@/pages/dashboard/Notifications";
import Expenses from "@/pages/dashboard/Expenses";
import Users from "@/pages/dashboard/Users";
import "@/App.css";

function DashboardIndex() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Overview />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={
              <ProtectedRoute><DashboardLayout /></ProtectedRoute>
            }>
              <Route index element={<DashboardIndex />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="book" element={<BookAppointment />} />
              <Route path="services" element={<Services />} />
              <Route path="staff" element={<ProtectedRoute roles={["admin", "staff", "receptionist", "manager"]}><Staff /></ProtectedRoute>} />
              <Route path="customers" element={<ProtectedRoute roles={["admin", "staff", "receptionist", "manager"]}><Customers /></ProtectedRoute>} />
              <Route path="inventory" element={<ProtectedRoute roles={["admin", "staff"]}><Inventory /></ProtectedRoute>} />
              <Route path="products" element={<ProtectedRoute roles={["admin", "staff", "receptionist", "manager"]}><Products /></ProtectedRoute>} />
              <Route path="suppliers" element={<ProtectedRoute roles={["admin", "staff", "receptionist", "manager"]}><Suppliers /></ProtectedRoute>} />
              <Route path="purchases" element={<ProtectedRoute roles={["admin", "staff", "receptionist", "manager"]}><Purchases /></ProtectedRoute>} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="calendar" element={<ProtectedRoute roles={["admin", "staff", "customer"]}><CalendarPage /></ProtectedRoute>} />
              <Route path="quick-sale" element={<ProtectedRoute roles={["admin", "staff", "receptionist", "manager"]}><QuickSale/></ProtectedRoute>} />
              <Route path="product-sale" element={<ProtectedRoute roles={["admin", "staff", "receptionist", "manager"]}><ProductSale/></ProtectedRoute>} />
              <Route path="payroll" element={<ProtectedRoute roles={["admin"]}><Payroll /></ProtectedRoute>} />
              <Route path="leave" element={<ProtectedRoute roles={["admin", "staff", "manager"]}><LeaveRequest /></ProtectedRoute>} />
              <Route path="salary-rules" element={<ProtectedRoute roles={["admin"]}><SalaryRules /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute roles={["admin"]}><Settings /></ProtectedRoute>} />
              <Route path="notifications" element={<ProtectedRoute roles={["admin"]}><Notifications /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
              <Route path="expenses" element={<ProtectedRoute roles={["admin"]}><Expenses /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
        </ConfirmProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
